import React from "react";
import merge from "deepmerge";
import Fab, { FabProps } from "@material-ui/core/Fab";
import { StyleRulesCallback, withStyles, WithStyles } from "@material-ui/core/styles";

import { HERO_CTA_ID_CONTAINER } from "../../../../../constants";

const styles: StyleRulesCallback = ({ spacing: { unit } }) => ({
  root: {
    boxShadow: "none",
    marginTop: unit * 7,
    minWidth: unit * 29,
    maxWidth: "250px",
    whiteSpace: "nowrap"
  }
});

export type CallToActionProps = FabProps & WithStyles<typeof styles>;
const ButtonBase: React.FC<CallToActionProps> = ({
  children,
  classes,
  onClick,
  href,
  color,
  className
}) => (
  <Fab
    onClick={onClick}
    variant="extended"
    color={color!}
    classes={classes}
    href={href}
    className={className}
    data-id={`${HERO_CTA_ID_CONTAINER}${color}`}
  >
    {children}
  </Fab>
);

ButtonBase.defaultProps = {
  color: "secondary"
};

export const CallToAction = withStyles(styles)(ButtonBase);

export const createCallToAction = (customStyles: StyleRulesCallback) => {
  const ctaStyles: StyleRulesCallback = theme => merge(styles(theme), customStyles(theme));

  return withStyles(ctaStyles)(ButtonBase);
};
